import * as React from 'react';
import styled from 'styled-components';
import { AddressInputButton } from '../addressInputButtonComponent';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { addressInputDisableState } from "../../states/addressInputDisableState";
import { useRecoilState, useRecoilValue } from 'recoil';
import { LoadingModal } from '../modal/loadingModalComponent';
import { Center,Box,Button,Text,useDisclosure,Image } from '@chakra-ui/react';
import { mintNFTTopShot } from '../../usecases/repositories/topShot';
import { nftJsonState } from '../../states/nftJsonState';
import { requestIdState } from '../../states/requestIdState';



type Props = {
    announceText:string,
    defaultWalletAddress:string,
}

export const AddressButtonSide: React.FC<Props> = (props) => {
  const nftJsonStatus = useRecoilValue(nftJsonState);
  const requestId = useRecoilValue(requestIdState);
  const [str, setStr] = React.useState("");
  const [t, i18n] = useTranslation();
  const [addressInputDisableStatus ,setAddressInputDisableStatus] = useRecoilState(addressInputDisableState);

  const informationStyle: React.CSSProperties = {
    fontSize: '13px',
    color: 'black',
    fontWeight:'bold',
  };
  const AddressInputRowComponent = styled.div`
    margin-top: 120px; 
  `;

  let stringValue:string = props.defaultWalletAddress;
  const addressInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    stringValue = String(event.target.value);
    console.log(stringValue);
  }
  const nav = useNavigate();


  return (
    <>
      <AddressInputRowComponent id='addressinputrow'>
          <p id='information' style={informationStyle}>{t(props.announceText)}</p>
          <AddressInputButton  
            disable={addressInputDisableStatus} 
            defaultValue={props.defaultWalletAddress} 
            inputId='addressinput' 
            onChange={addressInputOnChange} 
            switchToNFTRecievePageVoid={async()=>{
              const result =   await mintNFTTopShot(
                `${stringValue}`,
                `metaMask`,
                requestId,
                nftJsonStatus.nftmeta
              );
              if (result === `6`) {
                nav(`/${result}`,{state:{useWalletAddress:`${stringValue}`}});
              }else{
                nav(`/${result}`);
              }
            }}
          />
      </AddressInputRowComponent>

    </>
  );
};